import styled from 'styled-components'

const ButtonSmall = styled.div`
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: rgb(0, 0, 0, 0.75);
  color: ${(props) => props.theme.text};
  background:
    linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)) padding-box,
    linear-gradient(
        -205deg,
        ${(props) => props.theme.primary},
        ${(props) => props.theme.secondary}
      )
      border-box;
  border-radius: 0.25rem;
  border: 2px solid transparent;
  color: darkblue;
  padding: 0.25rem 0.75rem;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  font-size: 0.85rem;
`
export default ButtonSmall
